import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadioButtonChecked = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: 1,
		width: 17,
		height: 17,
		rx: 8.5,
		stroke: "#E5E5EA"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 9,
		cy: 9.49994,
		r: 5,
		fill: "#007AFF"
	})]
});
const ForwardRef = forwardRef(SvgRadioButtonChecked);
export default ForwardRef;
